module.exports = __webpack_public_path__ + "img/202203.21964235.png";